import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { HomeSimulation } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface SimulationParams extends DefaultHttpHeaders {
  /** project identifier code */
  projectQuoteId: string;
  /** Identifier of the company who owns the final contract */
  companyId?: string;
  version: string;
}

@Injectable()
export class SimulationService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Generates an insurance simulation from the risk of a project
   * Generates an insurance simulation from the risk of a project
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Project/getSimulationBySimulationId
   */
  simulation(params: SimulationParams): Observable<HomeSimulation[]> {
    const pathParams = {
      projectQuoteId: params.projectQuoteId,
    };
    const queryParams = {
      companyId: params.companyId,
      version: params.version,
    };

    return this.post<void, HomeSimulation[]>({
      suffix: `/home/project/${pathParams.projectQuoteId}/simulation`,
      queryParams,
      authenticationType: 'jwt',
    });
  }
}
